import Request from '../../utils/request'

export const CommonServer = {
    getSelfInfo() {
        return Request.$get('/api/account/self', {})
    },
    getCouponConfig() {
        return Request.$get(`/operating/api/outer/get_wksettings?model_name=common-coupon-config&key=common-coupon-config`, {})
    },
    /**
     * 获取跳转有课小程序的链接 link | scheme
     * @param link https://gitlab.weike.fm/oc/oc-docs/-/blob/yyl/operating/dispatch/小程序路由链接接口.md#2-获取小程序链接
     * @param tag  scheme / link
     * @link  测试环境Django后台 https://dbg.lizhiweike.com/oc_operating/admin/dispatch/xcxsetting/
     * @link  线上环境Django后台 https://m.lizhiweike.com/oc_operating/admin/dispatch/xcxsetting/
     * @param name Django后台配置对应的appID和secrect
     */
    xcx_path(params: { tag: 'scheme' | 'link'; name: string; data: any }) {
        return Request.$post(`/oc_operating/api/dispatch/xcx_path/`, params)
    }
}

export default CommonServer



// WEBPACK FOOTER //
// ./src/services/Modules/commonServer.ts